import React from 'react';
//import MD5 from "crypto-js/md5";

import TreeDVistaConnector from './3dvista.page';
import Sidebar from './components/sidebar/sidebar.component';
import Topbar from './components/topbar.component';
import Bottombar from './components/bottombar/bottombar.component';
import Intro from './components/intro.component';
import Quote from './components/quote.component';

import IsPortrait from './components/helpers/WindowOrientation';
import BrowserInfo from './components/helpers/BrowserInfo';

const AllFloors = require("../data/floor.data");
const AllPropertyType = require("../data/property.type.data");
const AllFinishes = require("../data/finishes.data");
const AllModules = require("../data/module.data");
const ModulesConfig = require("../data/configs.data");

const MainPage: React.FC = () => {

  const isPortrait = IsPortrait();
  const browserInfo = BrowserInfo();
  const url3DVista = browserInfo.isDeviceMobile === true ? './3dvista/mobile/v3/index.htm' : './3dvista/desktop/v3/index.htm';
  //const url3DVista = './3dvista/v5/index.htm';

  const [bottomMenu, setBottomMenu] = React.useState("Apartamento");
  const [tourLoaded, setTourLoaded] = React.useState(false);
  const [productsUpdated, setProductsUpdated] = React.useState(false);

  const [allFloorsUpdated, setAllFloorsUpdated] = React.useState<any>(null);
  const [allPropertyTypeUpdated, setAllPropertyTypeUpdated] = React.useState<any>(null);
  const [allFinishesUpdated, setAllFinishesUpdated] = React.useState<any>(null);
  const [allModulesUpdated, setAllModulesUpdated] = React.useState<any>(null);
  const [bookingURL, setBookingURL] = React.useState<string>("");
  const [bookingParams, setBookingParams] = React.useState<any>(null);

  const [showIntro, setShowIntro] = React.useState(true);
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const [audioMute, setAudioMute] = React.useState(false);

  const [totalPrice, setTotalPrice] = React.useState("$ 100.000.000 cop");
  const [selectedElements, setSelectedElements] = React.useState<any>([]);
  const [propertyType, setPropertyType] = React.useState<any>({});
  const [floor, setFloor] = React.useState<any>(null);
  const [property, setProperty] = React.useState<any>(null);

  const [showQuote, setShowQuote] = React.useState(false);
  const [showAlternative, setShowAlternative] = React.useState("");

  const [module1, setModule1] = React.useState<any>(null);
  const [module2, setModule2] = React.useState<any>(null);
  const [module3, setModule3] = React.useState<any>(null);
  const [module4, setModule4] = React.useState<any>(null);
  const [modulesCompleted, setModulesCompleted] = React.useState(false);

  const [finishesRail, setFinishesRail] = React.useState<any>(null);
  const [finishesFloor, setFinishesFloor] = React.useState<any>(null);
  const [finishesMeson, setFinishesMeson] = React.useState<any>(null);
  const [finishesWoodwork, setFinishesWoodwork] = React.useState<any>(null);

  const messageTo3DVistaRef = React.useRef<{ SendMessage: (type: string, data: any) => void } | null>(null);

  const onMessageReceivedFrom3DVista = (data: any) => {
    console.log("Message from iframe: ", data);////aqui llegan los mensajes de 3dvista
    if(data === 'tourLoaded'){
      setTourLoaded(true);
    }
  };
  
  const SendMessageTo3DVista = (type: string, data: any) => {
    if (messageTo3DVistaRef.current) {
      messageTo3DVistaRef.current.SendMessage(type, data);
    }
  };

  // const getMD5 = (value: string): string => {
  //   return MD5(value).toString();
  // };

  const UpdateUnitsPrices = (unitsDictionary: any) => {
    const allFloors = AllFloors.Data;
    for(const floorKey in allFloors){
      for(const aptoKey in allFloors[floorKey]){
        const apto = allFloors[floorKey][aptoKey];
        if(unitsDictionary[apto.moduleId]){
          apto.price_original = `${unitsDictionary[apto.moduleId].price}`;
        }
      }
    }
    return allFloors;
  };

  const UpdateUnitTypePrices = (featuresDictionary: any) => {
    const allPropertyTypes = AllPropertyType.Data;
    for(const propertyTypes of allPropertyTypes){
      if(propertyTypes.featureId && featuresDictionary[propertyTypes.featureId]){
        propertyTypes.price = `${featuresDictionary[propertyTypes.featureId].price}`;
      }
    }
    return allPropertyTypes;
  };

  const UpdateFinishesPrices = (featuresDictionary: any) => {
    const allFinishes = AllFinishes.Data;
    for(const unitTypeKey in allFinishes){
      for(const category of allFinishes[unitTypeKey]){
        for(const finishes of category.options){
          if(finishes.featureId && featuresDictionary[finishes.featureId]){
            finishes.price = `${featuresDictionary[finishes.featureId].price}`;
          }
        }
      }
    }
    return allFinishes;
  };

  const UpdateModulesPrices = (featuresDictionary: any) => {
    const allModules = AllModules.Data;
    for(const unitTypeKey in allModules){
      for(const module of allModules[unitTypeKey]){
        for(const product of module.options){
          if(product.featureId && featuresDictionary[product.featureId]){
            product.price = `${featuresDictionary[product.featureId].price}`;
          }
        }
      }
    }
    return allModules;
  };

  React.useEffect(() => {
    const GetJsonFromURL = async (url: string): Promise<any> => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error en la petición:", error);
      }
      return null;
    };

    const UpdatePrices = async () => {
      const unitsFromWeb = await GetJsonFromURL("https://api.smart-home.com.co/api/v1/getUnits/443044cc/bebb20f3");
      if(unitsFromWeb){
        const unitsDictionary: any = {};
        for(const unit of unitsFromWeb.units){
          unitsDictionary[unit.moduleId] = unit;
        }
        const floorsUpdated = UpdateUnitsPrices(unitsDictionary);
        setAllFloorsUpdated(floorsUpdated);
        console.log("Actualizados precios de apartamentos desde la web")
      }else{
        console.log("No se pudo actualizar precios de apartamentos desde la web")
        setAllFloorsUpdated(AllFloors.Data);
      }
      const featuresFromWeb = await GetJsonFromURL("https://api.smart-home.com.co/api/v1/getFeatures/443044cc/bebb20f3");
      if(featuresFromWeb){
        const featuresDictionary: any = {};
        for(const feature of featuresFromWeb.features){
          featuresDictionary[feature.featureId] = feature;
        }
        const propertyTypesUpdated = UpdateUnitTypePrices(featuresDictionary);
        setAllPropertyTypeUpdated(propertyTypesUpdated);
        const finishesUpdated = UpdateFinishesPrices(featuresDictionary);
        setAllFinishesUpdated(finishesUpdated);
        const modulesUpdated = UpdateModulesPrices(featuresDictionary);
        setAllModulesUpdated(modulesUpdated);
        console.log("Actualizados precios de productos desde la web")
      }else{
        setAllPropertyTypeUpdated(AllPropertyType.Data);
        setAllFinishesUpdated(AllFinishes.Data);
        setAllModulesUpdated(AllModules.Data);
        console.log("No se pudo actualizar precios de productos desde la web")
      }
      setProductsUpdated(true);
    };

    UpdatePrices();
  }, []);

  React.useEffect(() => {
    if(module1 === null){
      setModule2(null);
      setModule3(null);
      setModule4(null);
    }
    if(module2 === null){
      setModule3(null);
      setModule4(null);
    }
    if(module3 === null){
      setModule4(null);
    }
  }, [module1, module2, module3, module4]);

  React.useEffect(() => {
    if(!allFloorsUpdated)
      return;
    if(!allPropertyTypeUpdated)
      return;
    if(!allFinishesUpdated)
      return;
    if(!allModulesUpdated)
      return;
    let total = 0;
    const arrayElemnts: any = [];
    const bookingParams = new URLSearchParams("");
    
    if(property && propertyType){
      const originalPrice = PriceToNumber(property.price_original);
      // const modulesProperty = AllModules.Data[propertyType.id];
      // const id_price: any = {};
      // for(const modulesGroup of modulesProperty){
      //   for(const modules of modulesGroup.options){
      //     if(modules.included === true){
      //       id_price[modules.id] = PriceToNumber(modules.price);
      //     }
      //   }
      // }
      // for(const id in id_price){
      //   const price = PriceToNumber(id_price[id].price);
      //   originalPrice = originalPrice - price;
      // }
      
      // const finishesProperty = AllFinishes.Data[propertyType.id];
      // for(const finishesGroup of finishesProperty){
      //   for(const finishes of finishesGroup.options){
      //     if(finishes.included === true){
      //       const price = PriceToNumber(finishes.price);
      //       originalPrice = originalPrice - price;
      //     }
      //   }
      // }
      property.price = ""+originalPrice;
    }
    //console.log("property: ", property);
    if(property){
      const price = PriceToNumber(property.price)
      arrayElemnts.push(property);
      total = total + price;
      if(property.moduleId)
        bookingParams.set("moduleId", property.moduleId);
    }
    //console.log("propertyType: ", propertyType);
    if(propertyType){
      const price = PriceToNumber(propertyType.price)
      if(price > 0){
        arrayElemnts.push(propertyType);
        total = total + price;
        if(propertyType.featureId)
          bookingParams.set("unitTypeId", propertyType.featureId);
      }
    }
    //console.log("module1: ", module1);
    if(module1){
      const price = PriceToNumber(module1.price)
      arrayElemnts.push(module1);
      total = total + price;
      // if(module1.featureId)
      //   bookingParams.set("module1Id", module1.featureId);
    }
    //console.log("module2: ", module2);
    if(module2){
      const price = PriceToNumber(module2.price)
      arrayElemnts.push(module2);
      total = total + price;
      // if(module2.featureId)
      //   bookingParams.set("module2Id", module2.featureId);
    }
    //console.log("module3: ", module3);
    if(module3){
      const price = PriceToNumber(module3.price)
      arrayElemnts.push(module3);
      total = total + price;
      // if(module3.featureId)
      //   bookingParams.set("module3Id", module3.featureId);
    }
    //console.log("module4: ", module4);
    if(module4){
      const price = PriceToNumber(module4.price)
      arrayElemnts.push(module4);
      total = total + price;
      // if(module4.featureId)
      //   bookingParams.set("module4Id", module4.featureId);
    }
    //console.log("finishesRail: ", finishesRail);
    if(finishesRail){
      const price = PriceToNumber(finishesRail.price)
      arrayElemnts.push(finishesRail);
      total = total + price;
      // if(finishesRail.featureId)
      //   bookingParams.set("finishesRail", finishesRail.featureId);
    }
    //console.log("finishesWoodwork: ", finishesWoodwork);
    if(finishesWoodwork){
      const price = PriceToNumber(finishesWoodwork.price)
      arrayElemnts.push(finishesWoodwork);
      total = total + price;
      // if(finishesWoodwork.featureId)
      //   bookingParams.set("finishesWoodwork", finishesWoodwork.featureId);
    }
    //console.log("finishesFloor: ", finishesFloor);
    if(finishesFloor){
      const price = PriceToNumber(finishesFloor.price)
      arrayElemnts.push(finishesFloor);
      total = total + price;
      // if(finishesFloor.featureId)
      //   bookingParams.set("finishesFloor", finishesFloor.featureId);
    }
    //console.log("finishesMeson: ", finishesMeson);
    if(finishesMeson){
      const price = PriceToNumber(finishesMeson.price)
      arrayElemnts.push(finishesMeson);
      total = total + price;
      // if(finishesMeson.featureId)
      //   bookingParams.set("finishesMeson", finishesMeson.featureId);
    }
    // const hashString = `a540f6af-53fb-4f14-9587-d60cf72a2dc5?${bookingParams.toString()}`;
    // const hash = getMD5(hashString);
    // bookingParams.set("hash", hash);

    const params: any = {};
    for(const element of arrayElemnts){
      params[element.quote_text] = element.price;
    }
    setBookingParams(params);
    
    const bookingUrlParams = `https://dev.egt.com.co/masmetro/plan-de-pagos/?${bookingParams.toString()}`;
    //console.warn(`%cRESERVAS: ${bookingUrlParams}`, "color: red");
    setBookingURL(bookingUrlParams);
    setTotalPrice(NumberToPrice(total));
    setSelectedElements(arrayElemnts);

  }, [module1, module2, module3, module4,
      finishesRail, finishesFloor, finishesMeson, finishesWoodwork,
      property, propertyType,
      allFloorsUpdated, allPropertyTypeUpdated, allFinishesUpdated, allModulesUpdated,
  ]);

  const PriceToNumber = (price: string) => {    
    if(!price)
      return 0;
    const number = Number(price.replace(/,/g, ''));
    return number ? number : 0;
  };
  const NumberToPrice = (price: number) => {    
    const formatted = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(price) + " cop";
    return formatted;
  };

  React.useEffect(() => {
    if(!allFloorsUpdated)
      return;
    if(!allPropertyTypeUpdated)
      return;
    if(!allFinishesUpdated)
      return;
    if(!allModulesUpdated)
      return;

    const hostposts: any = [];

    if(propertyType.id === 'Básico'){
      if(finishesFloor){
        if(finishesFloor.id.toLowerCase().includes('concreto')){
          hostposts.push("Sala_Piso_Concreto");
          hostposts.push("Cocina_Piso_Concreto");
        }
        if(finishesFloor.id.toLowerCase().includes('madera')){
          hostposts.push("Sala_Piso_Madera");
          hostposts.push("Cocina_Piso_Madera");
        }
      }
      if(finishesMeson){
        if(finishesMeson.id.toLowerCase().includes('blanco')){
          hostposts.push("Sala_Meson_Blanco");
          hostposts.push("Cocina_Meson_Blanco");
        }
        if(finishesMeson.id.toLowerCase().includes('grafito')){
          hostposts.push("Sala_Meson_Grafito");
          hostposts.push("Cocina_Meson_Grafito");
        }
      }
      if(finishesWoodwork){
        if(finishesWoodwork.id.toLowerCase().includes("madera")){
          hostposts.push("Sala_carpinteria_Roble");
          hostposts.push("Cocina_carpinteria_Roble");
        }
        if(finishesWoodwork.id.toLowerCase().includes("grafito")){
          hostposts.push("Sala_carpinteria_Grafito");
          hostposts.push("Cocina_carpinteria_Grafito");
        }
      }

      //configuración modulaciones
      if(modulesCompleted === true){
        if(module1 && module2 && module3 && module4){
          const config = ModulesConfig.Data[propertyType.id];
          let selected_typology = 'NOOOOOOOOOOOOOOO';
          for(const typology in config){
            const modules = config[typology];
            //console.log(typology, modules)
            if(module1.id.includes(modules.module1) && module2.id.includes(modules.module2) && module3.id.includes(modules.module3) && module4.id.includes(modules.module4)){
              selected_typology = typology;
              break;
            }
          }

          let carpinteria = "Roble";
          if(finishesWoodwork.id.toLowerCase().includes("madera"))
            carpinteria = "Roble";
          if(finishesWoodwork.id.toLowerCase().includes("grafito"))
            carpinteria = "Grafito";

          let cama_sincama_sofa = "Cama";
          if(module2.id === "murphy" || module3.id === "murphy"){
            cama_sincama_sofa = "Cama";
            if(showAlternative === "Sofá")
              cama_sincama_sofa = "Sofa";
          }
          if(module2.id === "sinmurphy" || module3.id === "sinmurphy"){
            cama_sincama_sofa = "SinCama";
          }

          if(selected_typology === 'B' || selected_typology === 'C'){
            let meson = "Roble";
            if(finishesMeson.id.toLowerCase().includes("blanco"))
              meson = "Blanco";
            if(finishesMeson.id.toLowerCase().includes("grafito"))
              meson = "Grafito";

            hostposts.push(`Cocina_${selected_typology}_${cama_sincama_sofa}_Meson_${meson}_Carpinteria_${carpinteria}`);
            hostposts.push(`Sala_${selected_typology}_${cama_sincama_sofa}_Meson_${meson}_Carpinteria_${carpinteria}`);
          }else{
            //module2 && module3
            hostposts.push(`Cocina_${selected_typology}_${cama_sincama_sofa}_Carpinteria_${carpinteria}`);
            hostposts.push(`Sala_${selected_typology}_${cama_sincama_sofa}_Carpinteria_${carpinteria}`);
          }
          
        }
      }
    }
    /////////////////////////////////////////////////////////////////////
    if(propertyType.id === 'Liviano'){

      if(finishesFloor){
        if(finishesFloor.id.toLowerCase().includes('concreto')){
          hostposts.push("Sala_piso_concreto");
          hostposts.push("Mezzanine_piso_concreto");
        }
        if(finishesFloor.id.toLowerCase().includes('madera')){
          hostposts.push("Sala_piso_madera");
          hostposts.push("Mezzanine_piso_madera");
        }
      }
      let meson = "blanco";
      if(finishesMeson){
        if(finishesMeson.id.toLowerCase().includes('blanco')){
          meson = "blanco";
          hostposts.push("Sala_meson_Blanco");
          hostposts.push("Mezzanine_meson_madera");
        }
        if(finishesMeson.id.toLowerCase().includes('grafito')){
          meson = "Grafito";
          hostposts.push("Sala_meson_grafito");
          hostposts.push("Mezzanine_meson_grafito");
        }
      }
      let carpinteria = "roble";
      if(finishesWoodwork){
        if(finishesWoodwork.id.toLowerCase().includes("madera")){
          carpinteria = "roble";
          hostposts.push("Sala_Carpinteria_Roble");
          hostposts.push("Mezzanine_Carpinteria_Roble");
        }
        if(finishesWoodwork.id.toLowerCase().includes("grafito")){
          carpinteria = "Grafito";
          hostposts.push("Sala_Carpinteria_grafito");
          hostposts.push("Mezzanine_Carpinteria_grafito");
        }
      }
      if(finishesRail){
        if(finishesRail.id.toLowerCase().includes("malla")){
          hostposts.push("Sala_baranda_Malla");
          hostposts.push("Mezzanine_baranda_Malla");
        }
        if(finishesRail.id.toLowerCase().includes("policarbonato")){
          hostposts.push("Sala_baranda_policarbonato");
          hostposts.push("Mezzanine_baranda_policarbonato");
        }
      }

      if(finishesRail){
        if(finishesRail.id.toLowerCase().includes("malla")){
          hostposts.push("Sala_baranda_Malla");
          hostposts.push("Mezzanine_baranda_Malla");
        }
        if(finishesRail.id.toLowerCase().includes("policarbonato")){
          hostposts.push("Sala_baranda_Policarbonato");
          hostposts.push("Mezzanine_baranda_Policarbonato");
        }
      }
      if(module1){
        if(module1.id.toLowerCase().includes("bolillo")){
          hostposts.push(`Sala_G_Bolillo_Carpinteria_${carpinteria}`);
          hostposts.push(`Mezzanine_G_Bolillo_Carpinteria_${carpinteria}`);
        }
        if(module1.id.toLowerCase().includes("escritorio")){
          hostposts.push(`Sala_G_Escritorio_Carpinteria_${carpinteria}`);
          hostposts.push(`Mezzanine_G_Escritorio_Carpinteria_${carpinteria}`);
        }
      }
      if(module2){
        if(module2.id.toLowerCase().includes("lavamanos")){
          hostposts.push(`Sala_H_lavamanos_meson_${meson}_carpinteria_${carpinteria}`);
          hostposts.push(`Mezzanine_H_lavamanos_meson_${meson}_carpinteria_${carpinteria}`);
        }
        if(module2.id.toLowerCase().includes("cajonera")){
          hostposts.push(`Sala_H_closet_carpinteria_${carpinteria}`);
          hostposts.push(`Mezzanine_H_closet_carpinteria_${carpinteria}`);
        }
      }

    }
    SendMessageTo3DVista("hotspots", hostposts);
  }, [module1, module2, module3, module4,
      modulesCompleted,
      finishesRail, finishesFloor, finishesMeson, finishesWoodwork,
      propertyType, showAlternative,
      allFloorsUpdated, allPropertyTypeUpdated, allFinishesUpdated, allModulesUpdated,
  ]);

  React.useEffect(() => {
    const place = propertyType.id === "Básico" ? "Tipo1_Cocina" : "Mezanine_Sala";
    SendMessageTo3DVista("location", place);
  }, [propertyType]);  

  return (
    <div className={`tour-full-container ${isPortrait ? 'portrait':''}`}>
      <TreeDVistaConnector url3DVista={url3DVista} messageTo3DVistaRef={messageTo3DVistaRef} onMessageReceivedFrom3DVista={onMessageReceivedFrom3DVista}/>
      <Quote isPortrait={isPortrait} propertyType={propertyType} showQuote={showQuote} setShowQuote={setShowQuote} selectedElements={selectedElements} totalPrice={totalPrice} bookingURL={bookingURL} bookingParams={bookingParams}/>
      <Intro isPortrait={isPortrait} showIntro={showIntro} setShowIntro={setShowIntro} tourLoaded={tourLoaded} productsUpdated={productsUpdated}/>

      {(!isPortrait && productsUpdated) && <Topbar showIntro={showIntro} audioMute={audioMute} propertyType={propertyType} floor={floor} showQuote={showQuote} totalPrice={totalPrice} modulesCompleted={modulesCompleted} allFloorsUpdated={allFloorsUpdated} allPropertyTypeUpdated={allPropertyTypeUpdated}
                              setShowQuote={setShowQuote} setFloor={setFloor} setPropertyType={setPropertyType} setAudioMute={setAudioMute} property={property} setProperty={setProperty}/>}
      {(!isPortrait && productsUpdated) && <Sidebar  showIntro={showIntro} isCollapsed={isCollapsed} propertyType={propertyType}
                                module1={module1} module2={module2} module3={module3} module4={module4} allFinishesUpdated={allFinishesUpdated} allModulesUpdated={allModulesUpdated}
                                showAlternative={showAlternative} setShowAlternative={setShowAlternative}
                                finishesRail={finishesRail} modulesCompleted={modulesCompleted} finishesFloor={finishesFloor} finishesMeson={finishesMeson} finishesWoodwork={finishesWoodwork}
                                setIsCollapsed={setIsCollapsed} setModule1={setModule1} setModule2={setModule2} setModule3={setModule3} setModule4={setModule4}
                                setFinishesRail={setFinishesRail} setFinishesFloor={setFinishesFloor} setFinishesMeson={setFinishesMeson} setFinishesWoodwork={setFinishesWoodwork} setModulesCompleted={setModulesCompleted}/>}

      {(isPortrait && productsUpdated) && <Bottombar showIntro={showIntro} isCollapsed={isCollapsed} propertyType={propertyType}
                                module1={module1} module2={module2} module3={module3} module4={module4}
                                finishesRail={finishesRail} modulesCompleted={modulesCompleted} finishesFloor={finishesFloor} finishesMeson={finishesMeson} finishesWoodwork={finishesWoodwork}
                                setIsCollapsed={setIsCollapsed} setModule1={setModule1} setModule2={setModule2} setModule3={setModule3} setModule4={setModule4}
                                setFinishesRail={setFinishesRail} setFinishesFloor={setFinishesFloor} setFinishesMeson={setFinishesMeson} setFinishesWoodwork={setFinishesWoodwork} setModulesCompleted={setModulesCompleted} bottomMenu={bottomMenu} setBottomMenu={setBottomMenu}
                                audioMute={audioMute} floor={floor} showQuote={showQuote} totalPrice={totalPrice}
                                showAlternative={showAlternative} setShowAlternative={setShowAlternative}
                                setShowQuote={setShowQuote} setFloor={setFloor} setPropertyType={setPropertyType} setAudioMute={setAudioMute} property={property} setProperty={setProperty}
                                allFloorsUpdated={allFloorsUpdated} allPropertyTypeUpdated={allPropertyTypeUpdated} allModulesUpdated={allModulesUpdated} allFinishesUpdated={allFinishesUpdated}/>}
      
    </div>
  );
};

export default MainPage;